<template>
  <main>

    <NavigationCard image="/assets/img/News/navigation.png" title="S LONG" />

    <div class="page_content content_padding">
      <RouteNav></RouteNav>
      <div class="pt-3 pb-3">
        <section class="page_header">
          <div class="container row">
            <div class=" col-md-6">
              <h3 class="text-left page_title">
                <span>Long</span>
              </h3>
            </div>
            <div class="col-md-6 page_search">
              <SearchInput v-model="inputValue" />
            </div>
          </div>
        </section>


        <section class="container long_content text-white mt-4">
          <div class="row long-item pt-3 pb-3">
            <div class="col-lg-5 pr-4">
              <div class="overlay border-0">
                <img class="card-img" src="/assets/img/News/long1.png" alt="Card image">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="overlay border-0 text-left">
                <h5 class="card-title mt-1 mb-4">2024 LAS VEGAS AAPEX SHOW RECSP</h5>
                <p class="card-text text-muted mb-4">
                  The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products
                  Expo, is one of the largest automotive aftermarket trade shows in the world. It
                  brings together manufacturers, distributors, retailers, and service professionals
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <span class="card-text text-muted">
                      2024/11/24
                    </span>
                  </div>
                  <div class="col-md-6 text-right">
                    <button class="btn custom-btn-primary">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row long-item pt-3 pb-3">
            <div class="col-lg-5 pr-4">
              <div class="overlay border-0">
                <img class="card-img" src="/assets/img/News/long2.png" alt="Card image">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="overlay border-0 text-left">
                <h5 class="card-title mt-1 mb-4">2024 LAS VEGAS AAPEX SHOW RECSP</h5>
                <p class="card-text text-muted mb-4">
                  The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products
                  Expo, is one of the largest automotive aftermarket trade shows in the world. It
                  brings together manufacturers, distributors, retailers, and service professionals
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <span class="card-text text-muted">
                      2024/11/24
                    </span>
                  </div>
                  <div class="col-md-6 text-right">
                    <button class="btn custom-btn-primary">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row long-item pt-3 pb-3">
            <div class="col-lg-5 pr-4">
              <div class="overlay border-0">
                <img class="card-img" src="/assets/img/News/long3.png" alt="Card image">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="overlay border-0 text-left">
                <h5 class="card-title mt-1 mb-4">2024 LAS VEGAS AAPEX SHOW RECSP</h5>
                <p class="card-text text-muted mb-4">
                  The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products
                  Expo, is one of the largest automotive aftermarket trade shows in the world. It
                  brings together manufacturers, distributors, retailers, and service professionals
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <span class="card-text text-muted">
                      2024/11/24
                    </span>
                  </div>
                  <div class="col-md-6 text-right">
                    <button class="btn custom-btn-primary">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row long-item pt-3 pb-3">
            <div class="col-lg-5 pr-4">
              <div class="overlay border-0">
                <img class="card-img" src="/assets/img/News/long4.png" alt="Card image">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="overlay border-0 text-left">
                <h5 class="card-title mt-1 mb-4">2024 LAS VEGAS AAPEX SHOW RECSP</h5>
                <p class="card-text text-muted mb-4">
                  The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products
                  Expo, is one of the largest automotive aftermarket trade shows in the world. It
                  brings together manufacturers, distributors, retailers, and service professionals
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <span class="card-text text-muted">
                      2024/11/24 
                    </span>
                  </div>
                  <div class="col-md-6 text-right">
                    <button class="btn custom-btn-primary">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row long-item pt-3 pb-3">
            <div class="col-lg-5 pr-4">
              <div class="overlay border-0">
                <img class="card-img" src="/assets/img/News/long5.png" alt="Card image">
              </div>
            </div>
            <div class="col-lg-7">
              <div class="overlay border-0 text-left">
                <h5 class="card-title mt-1 mb-4">2024 LAS VEGAS AAPEX SHOW RECSP</h5>
                <p class="card-text text-muted mb-4">
                  The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products
                  Expo, is one of the largest automotive aftermarket trade shows in the world. It
                  brings together manufacturers, distributors, retailers, and service professionals
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <span class="card-text text-muted">
                      2024/11/24
                    </span>
                  </div>
                  <div class="col-md-6 text-right">
                    <button class="btn custom-btn-primary">Read More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>


  </main>
</template>

<script>
import NavigationCard from '@/components/common/TopVideo.vue';
import RouteNav from '@/components/common/RouteNav.vue';
import SearchInput from '@/components/common/SearchInput.vue';
export default {
  name: 'SLong',
  components: {
    NavigationCard,
    RouteNav,
    SearchInput
  },
  data() {
    return {
      inputValue: '',
    };
  },
  methods: {

  },
};
</script>

<style scoped>
@import '../../assets/css/main.css';

:deep(.page_search) {
  display: flex;
  justify-content: right;
}


:deep(.long_content img) {
  max-height: 16rem;
}

:deep(.long_content p) {
  position: relative;
  display: flex;
  align-items: center;
}

:deep(.long_content p) {
  overflow: hidden;
  font-size: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>
